import { useEffect, useState } from "react";
import { Truck, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { obtenerUsuariosMovilHabilitados } from "../api/api-usuario-movil";
import Select from "react-select";
import { obtenerListaPais } from "../api/api-pais";
import { obtenerListaCiudadPorPais } from "../api/api-ciudad";
import Switch from "./switch";
import ModalUnidadesDisponibles from "./modal-unidades-disponibles";

/**
 * Placeholder modal for future advanced assignment options.
 */
export default function ModalAsignacionOpcionesAvanzadas({
  visible = false,
  onClose,
  opcionesAvanzadas,
  setOpcionesAvanzadas,
  showToast,
  setProcessingVisible,
}) {

  const { t } = useTranslation();

  const [listaUnidadesActivas, setListaUnidadesActivas] = useState([]);
  const [listaUnidadesParaFiltrar, setListaUnidadesParaFiltrar] = useState([]);
  const [listaPaises, setListaPaises] = useState([]);
  const [paisSelected, setPaisSelected] = useState(null);
  const [listaCiudades, setListaCiudades] = useState([]);
  const [ciudadSelected, setCiudadSelected] = useState(null);

  const [switchAsignarPorPeso, setSwitchAsignarPorPeso] = useState(false);
  const [switchUsarVehiculoSoloUnaVez, setSwitchUsarVehiculoSoloUnaVez] = useState(false);
  const [switchUsarVehiculoDelExcel, setSwitchUsarVehiculoDelExcel] = useState(false);
  const [switchDividirSiNoSeEncuentraVehiculo, setSwitchDividirSiNoSeEncuentraVehiculo] = useState(false);

  const [modalUnidadesVisible, setModalUnidadesVisible] = useState(false);


  useEffect(() => {
    if (visible) {
      iniciar();
      // console.log('opcionesAvanzadas');
      // console.log(opcionesAvanzadas);
    }
  }, [visible]);

  const iniciar = async () => {
    try {
      const unidadesActivas = await obtenerUsuariosMovilHabilitados();
      // console.log('unidadesActivas');
      // console.log(unidadesActivas);
      setListaUnidadesActivas(unidadesActivas);
      setListaUnidadesParaFiltrar(unidadesActivas);
      const listaP = await obtenerListaPais({ habilitado: 1 }, true);
      // console.log('listaP');
      // console.log(listaP);
      setListaPaises(listaP);
    } catch (error) {
      console.log('iniciar error');
      console.log(error);
    }
  };

  useEffect(() => {
    setListaCiudades([]);
    setCiudadSelected(null);
    if (paisSelected !== null) {
      buscarCiudadesPorPais();
      // console.log('listaUnidadesActivas');
      // console.log(listaUnidadesActivas);
      let unidadesActivas = [...listaUnidadesParaFiltrar];
      unidadesActivas = unidadesActivas.filter((item) => item.idPais === paisSelected.value);
      setListaUnidadesActivas(unidadesActivas);
    }
    if (paisSelected === null) {
      let unidadesActivas = [...listaUnidadesParaFiltrar];
      setListaUnidadesActivas(unidadesActivas);
    }
  }, [paisSelected]);

  const buscarCiudadesPorPais = async () => {
    try {
      setProcessingVisible(true);
      const ciudades = await obtenerListaCiudadPorPais({ idPais: paisSelected.value }, true, t);
      setListaCiudades(ciudades);
    } catch (error) {
      console.log('buscarCiudadesPorPais error');
      console.log(error);
    } finally {
      setProcessingVisible(false);
    }
  };

  useEffect(() => {
    if (ciudadSelected !== null) {
      let unidadesActivas = [...listaUnidadesParaFiltrar];
      unidadesActivas = unidadesActivas.filter(
        (item) =>
          item.idCiudad === ciudadSelected.value &&
          item.idPais === paisSelected.value);
      setListaUnidadesActivas(unidadesActivas);
    }
    if (ciudadSelected === null) {
      if (paisSelected !== null) {
        let unidadesActivas = [...listaUnidadesParaFiltrar];
        unidadesActivas = unidadesActivas.filter((item) => item.idPais === paisSelected.value);
        setListaUnidadesActivas(unidadesActivas);
      }
      if (paisSelected === null) {
        let unidadesActivas = [...listaUnidadesParaFiltrar];
        setListaUnidadesActivas(unidadesActivas);
      }
    }
  }, [ciudadSelected]);

  const onClickAceptar = () => {
    // console.log('onClickAceptar');
    // console.log(listaUnidadesActivas);
    const opciones = {
      listaUnidadesActivas: listaUnidadesActivas,
      switchUsarVehiculoDelExcel: switchUsarVehiculoDelExcel,
      switchAsignarPorPeso: switchAsignarPorPeso,
      switchUsarVehiculoSoloUnaVez: switchUsarVehiculoSoloUnaVez,
      switchDividirSiNoSeEncuentraVehiculo: switchDividirSiNoSeEncuentraVehiculo,
    };
    // console.log('opciones');
    // console.log(opciones);
    setOpcionesAvanzadas(opciones);
    onClose();
  };

  const onClickUnidadesDisponibles = () => {
    setModalUnidadesVisible(true);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[99] flex items-center justify-center bg-black/40 p-4">
      <div className="bg-white rounded-lg shadow-xl border border-gray-200 w-full max-w-3xl max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 flex-shrink-0">
          <h3 className="text-lg font-semibold text-gray-900 m-0">
            {t("label_opciones_avanzadas")}
          </h3>
          <button
            type="button"
            className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
            onClick={onClose}
            aria-label={t("label_cerrar")}
          >
            <X className="h-5 w-5 text-gray-600" />
          </button>
        </div>
        <div className="flex-1 min-h-[400px] p-4">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1.5">{t("label_pais")}</label>
              <Select
                options={listaPaises}
                value={paisSelected}
                onChange={(option) => setPaisSelected(option)}
                placeholder={t("placeholder_seleccione_pais")}
                isClearable={true}
                isSearchable={true}
                classNamePrefix="react-select"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 999 }),
                  menu: (base) => ({ ...base, zIndex: 999 }),
                }}
              />
            </div>
            <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700 mb-1.5">{t("label_ciudad")}</label>
              <Select
                options={listaCiudades}
                value={ciudadSelected}
                onChange={(option) => setCiudadSelected(option)}
                placeholder={t("placeholder_seleccione_ciudad")}
                isClearable={true}
                isSearchable={true}
                classNamePrefix="react-select"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 999 }),
                  menu: (base) => ({ ...base, zIndex: 999 }),
                }}
              />
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4 mt-4">
            <div className="col-span-12 md:col-span-12 lg:col-span-3 xl:col-span-3">
              <label className="block text-sm font-medium text-gray-700">{t("label_asignar_por_peso")}</label>
              <div className="flex items-center gap-2">
                <Switch
                  checked={switchAsignarPorPeso}
                  onChange={(checked) => setSwitchAsignarPorPeso(checked)}
                />
                <label className="text-sm text-gray-700">{switchAsignarPorPeso ? t("label_si") : t("label_no")}</label>
              </div>
            </div>
            <div className="col-span-12 md:col-span-12 lg:col-span-3 xl:col-span-3">
              <label className="block text-sm font-medium text-gray-700">{t("label_usar_vehiculo_solo_una_vez")}</label>
              <div className="flex items-center gap-2">
                <Switch
                  checked={switchUsarVehiculoSoloUnaVez}
                  onChange={(checked) => setSwitchUsarVehiculoSoloUnaVez(checked)}
                />
                <label className="text-sm text-gray-700">{switchUsarVehiculoSoloUnaVez ? t("label_si") : t("label_no")}</label>
              </div>
            </div>
            <div className="col-span-12 md:col-span-12 lg:col-span-3 xl:col-span-3">
              <label className="block text-sm font-medium text-gray-700">{t("label_usar_vehiculo_del_excel")}</label>
              <div className="flex items-center gap-2">
                <Switch
                  checked={switchUsarVehiculoDelExcel}
                  onChange={(checked) => setSwitchUsarVehiculoDelExcel(checked)}
                />
                <label className="text-sm text-gray-700">{switchUsarVehiculoDelExcel ? t("label_si") : t("label_no")}</label>
              </div>
            </div>
            <div className="col-span-12 md:col-span-12 lg:col-span-3 xl:col-span-3">
              <label className="block text-sm font-medium text-gray-700">{t("label_dividir_si_no_se_encuentra_vehiculo")}</label>
              <div className="flex items-center gap-2">
                <Switch
                  checked={switchDividirSiNoSeEncuentraVehiculo}
                  onChange={(checked) => setSwitchDividirSiNoSeEncuentraVehiculo(checked)}
                />
                <label className="text-sm text-gray-700">{switchDividirSiNoSeEncuentraVehiculo ? t("label_si") : t("label_no")}</label>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4 mt-4">
            <div className="col-span-12 md:col-span-12 lg:col-span-4 xl:col-span-4 cursor-pointer">
              <label className="block text-sm font-medium text-gray-700">{t("label_unidades_disponibles")}</label>
              <div className="flex items-center gap-2"
                onClick={onClickUnidadesDisponibles}
              >
                <Truck className="h-4 w-4" /> <label className="text-sm text-gray-700">{listaUnidadesActivas.length}</label>
              </div>
            </div>
          </div>
        </div>
        <div className="px-4 py-3 border-t border-gray-200 flex justify-between flex-shrink-0">
          <button
            type="button"
            className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md text-sm"
            onClick={onClose}
          >
            {t("label_cerrar")}
          </button>
          <button
            type="button"
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm"
            onClick={onClickAceptar}
          >
            {t("label_aceptar")}
          </button>
        </div>
      </div>
      <ModalUnidadesDisponibles
        visible={modalUnidadesVisible}
        onClose={() => setModalUnidadesVisible(false)}
        unidades={listaUnidadesActivas}
      />
    </div>
  );
}
